import * as React from 'react';

import type { EnterpriseSkills_Skillset as SkillSet } from '__generated__/graphql-types-do-not-use';

import { Grid, Hidden } from '@coursera/cds-core';

import { SkillSetCardV3, SkillSetCardV3Placeholder } from 'bundles/program-home/components/multiprogram/SkillSetCardV3';
import type { ObjectiveListQuery_EnterpriseTargetSkillProfileSummariesV1Resource_byProgram_elements as TargetSkillProficiencySummary } from 'bundles/program-home/components/multiprogram/__generated__/ObjectiveListQuery';

type SkillSetGridProp = {
  objectives: TargetSkillProficiencySummary[] | SkillSet[];
  programSlug: string;
};

type PlaceholderProp = {
  skillSetLength?: number;
};

export const MAX_NUMBER_OF_SKILLSETS = 6;
export const SkillSetsGrid = ({ objectives, programSlug }: SkillSetGridProp) => {
  return (
    <Grid container spacing={24}>
      {objectives.slice(0, MAX_NUMBER_OF_SKILLSETS).map((objective, index) => (
        <Grid
          component={Hidden}
          item
          md={4}
          sm={index < 4 ? 6 : undefined}
          xs={index < 2 ? 12 : undefined}
          smDown={index >= 4}
          xsDown={index >= 2}
          key={objective.id}
        >
          <SkillSetCardV3 skillSummary={objective} programSlug={programSlug} skillSetOrder={index + 1} />
        </Grid>
      ))}
    </Grid>
  );
};

export const SkillSetsGridPlaceholder = ({ skillSetLength }: PlaceholderProp) => {
  return (
    <Grid container spacing={24}>
      {[...Array(skillSetLength && skillSetLength <= 6 ? skillSetLength : 6).keys()].map((placeholder, index) => (
        <Grid
          component={Hidden}
          item
          md={4}
          sm={index < 4 ? 6 : undefined}
          xs={index < 2 ? 12 : undefined}
          smDown={index >= 4}
          xsDown={index >= 2}
          key={placeholder}
        >
          <SkillSetCardV3Placeholder />
        </Grid>
      ))}
    </Grid>
  );
};
